var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 33,
    viewBox: "0 0 23 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.629883 0.230225H2.12988V2.23022H0.629883V0.230225ZM0.629883 6.22021H2.12988V10.2102H0.629883V6.22021ZM2.12988 22.1802H0.629883V26.1702H2.12988V22.1802ZM0.629883 14.2002H2.12988V18.1902H0.629883V14.2002ZM2.12988 30.1603H0.629883V32.1603H2.12988V30.1603ZM18.7402 3.90018L19.6102 2.68018C20.8702 3.57018 21.8102 4.69018 22.4202 5.98018L21.0602 6.62018C20.5602 5.56018 19.7802 4.64018 18.7402 3.90018ZM3.55957 2.99019L4.59958 4.07019C5.33958 3.36019 6.35958 2.8702 7.79958 2.5302L7.44957 1.07019C5.73957 1.48019 4.49957 2.09019 3.55957 2.99019ZM11.6198 2.02027L11.5498 0.520272L11.5598 0.510277C12.9998 0.440277 14.4098 0.590281 15.7398 0.920281L15.3698 2.38027C14.1898 2.09027 12.9198 1.96027 11.6198 2.02027Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerR);
export default __webpack_public_path__ + "static/media/LOWER_R.a384f462683453baa7417a762b1ff145.svg";
export { ForwardRef as ReactComponent };